import CaptchaPresenter from "../components/captcha/presenter/captcha.js";

const captchaComponent = new CaptchaPresenter();
captchaComponent.init();
